<div class="flex justify-center items-center h-screen">
    <div>
        <div class="text-4xl font-medium text-gray-700">You are not authorized!</div>
        <div class="text-xl mt-4">Please verify your email to continue.</div>
        <div class="flex items-center space-x-4 mt-4">
            <app-button variant="filled" severity="primary" [label]="sendMailLabel" (clicked)="sendVerificationEmail()"
                [disabled]="mailSent" [loading]="sendingMail" />
            <div *ngIf="mailSent" class="text-xl flex animate-pulse align-baseline items-center">
                <i class="pi pi-check-circle text-success mr-2"></i>
                <span class="text-success">Mail sent</span>
            </div>
        </div>
        @if(mailSent){
        <div class="flex flex-col items-start gap-4 mt-4 animate-fade-in-up">
            <div>Not received mail? <span class="text-arena-orange cursor-pointer"
                    (click)="sendVerificationEmail()">Resend</span>
            </div>
            <p-divider class="w-full h-0.5 bg-slate-300" type="solid" />
            <span class="text-lg font-medium">Enter the OTP sent to your email</span>
            <p-inputOtp [integerOnly]="true" [length]="6" [(ngModel)]="otp" />
            <app-button variant="filled" severity="primary" label="Verify" (clicked)="verifyOTP()"
                [disabled]="otp.length !== 6" />
            <div *ngIf="otpVerified" class="text-xl flex animate-fade-in-up align-baseline items-center">
                <i class="pi pi-check-circle text-success mr-2"></i>
                <span class="text-success">Otp verified</span>
            </div>
        </div>
        }
    </div>
</div>